import Student from "../views/Student/Student";
import StudentCoursesList from "../views/Student/StudentCoursesList";
import StudentProfile from "../views/Student/StudentProfile";
import StudentResults from "../views/Student/StudentResults";
import Notifications from "../views/Notifications/Notifications";
import StudentCourseModules from "../views/Student/StudentCourseModules";

const navRoutesStudent = [
  { path: "/", exact: true, name: "Home", component: Student },
  { path: "/student", exact: true, name: "Home", component: Student },
  { path: "/student/courses", name: "Courses", component: StudentCoursesList },
  {
    path: "/student/studentprofile",
    name: "Profile",
    component: StudentProfile,
  },
  {
    path: "/student/studentresults",
    name: "Results",
    component: StudentResults,
  },
  {
    path: "/student/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/student/coursemodules/:courseId/",
    name: "CourseModules",
    component: StudentCourseModules,
  },
];

export default navRoutesStudent;
